/*
 * Print buy box — the popular configurations' Add to cart
 * (blocks/print-configuration.liquid). Each card is a real form posting the
 * print variant with its line item properties - the photograph, its
 * orientation, a centred crop - so it works with scripts off. With them, the
 * crop is drawn as the reference image the print wizard sends too (a file
 * property, kept by Shopify and linked from the order line), and the add is
 * handed to the cart drawer through a `cart:add` event, as the product page's
 * own Add to cart does (assets/section-product.js); a refusal is shown on
 * the card. No drawer on the page: the form posts as it is.
 *
 * Also: in the theme editor, the Customise button says when there is no
 * Print wizard on the page for it to open.
 */

// Bare name, resolved by the import map in layout/theme.liquid.
import { cropReferenceImage, rectFromCrop, CROP_REFERENCE } from 'print-model';

const lineProperties = (form) => {
  const properties = {};
  new FormData(form).forEach((value, name) => {
    const match = /^properties\[(.+)\]$/.exec(name);
    if (match && typeof value === 'string' && value !== '') properties[match[1]] = value;
  });
  return properties;
};

document.addEventListener('submit', async (event) => {
  const form = event.target.closest('[data-print-config-form]');
  if (!form) return;
  const button = form.querySelector('button[type="submit"]');
  const error = form.querySelector('[data-print-config-error]');
  if (button && button.getAttribute('aria-busy') === 'true') {
    event.preventDefault();
    return;
  }
  const idInput = form.querySelector('input[name="id"]');
  if (!idInput) return;
  event.preventDefault();

  if (error) {
    error.textContent = '';
    error.hidden = true;
  }
  if (button) button.setAttribute('aria-busy', 'true');
  const properties = lineProperties(form);
  let crop = null;
  try {
    crop = properties._crop ? JSON.parse(properties._crop) : null;
  } catch (parseError) {
    crop = null;
  }
  const reference =
    properties._photo_image && crop
      ? await cropReferenceImage({ src: properties._photo_image, imageWidth: crop.sourceWidth, rect: rectFromCrop(crop), name: `${properties._photo_handle || 'print'}-crop.jpg` })
      : null;
  const detail = {
    variantId: idInput.value,
    quantity: 1,
    properties,
    files: reference ? { [CROP_REFERENCE]: reference } : null,
    handled: false,
    done: (ok, message) => {
      if (button) button.removeAttribute('aria-busy');
      if (ok || !error) return;
      error.textContent = message || "This couldn't be added to your cart. Please try again.";
      error.hidden = false;
    },
  };
  document.dispatchEvent(new CustomEvent('cart:add', { detail }));
  // No drawer on the page: the plain post adds it and lands on the cart page.
  if (!detail.handled) form.submit();
});

// Theme editor: a Customise button with no wizard to open says so.
if (window.Shopify && window.Shopify.designMode) {
  const check = () => {
    const hasWizard = Boolean(document.querySelector('print-wizard'));
    document.querySelectorAll('[data-print-customise-hint]').forEach((hint) => {
      hint.hidden = hasWizard;
    });
  };
  check();
  document.addEventListener('shopify:section:load', check);
  document.addEventListener('shopify:section:unload', () => window.setTimeout(check, 0));
}
